/**
 * Scroll discreto: barra fina, sem trilho e com cantos arredondados.
 *
 * Uso dentro de um styled-component: `${scrollDiscreto()}` estiliza a barra do
 * próprio elemento; `${scrollDiscreto({ descendentes: true })}` estiliza a dos
 * elementos internos que rolam (equivale a `::-webkit-scrollbar` sem `&`).
 * `thumb`/`thumbHover` trocam a cor da barra.
 *
 * O rockfeller-content-components tem uma cópia em utils/scroll.js, porque o
 * submódulo roda em hosts que não têm este arquivo.
 */
export default function scrollDiscreto({
  thumb = 'rgba(0, 0, 0, 0.2)',
  thumbHover = 'rgba(0, 0, 0, 0.35)',
  descendentes = false
} = {}) {
  const alvo = descendentes ? '& ' : '&';
  // scrollbar-color é herdado e, no Chrome 121+, faz os ::-webkit-scrollbar
  // serem ignorados. Para os descendentes, fica só a versão -webkit-.
  const padrao = descendentes
    ? ''
    : `scrollbar-width: thin;
  scrollbar-color: ${thumb} transparent;`;

  return `
  ${padrao}

  ${alvo}::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  ${alvo}::-webkit-scrollbar-track {
    background: transparent;
  }

  ${alvo}::-webkit-scrollbar-thumb {
    background: ${thumb};
    border-radius: 999px;
  }

  ${alvo}::-webkit-scrollbar-thumb:hover {
    background: ${thumbHover};
  }
`;
}
